onDomLoad(function ($dom) {
  $dom.find("[data-behavior='auto-reload-page']").each(function (_, item) {
    setTimeout(function () {
      window.location.reload()
    }, $(item).data('reload-timeout'))
  })
})
